import { Offcanvas, Collapse } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
    initMobileDrawer();
    initDesktopDropdownSplit();
    initSkipLink();
});

// Close the offcanvas drawer when a leaf nav link is clicked (not toggles).
function initMobileDrawer() {
    const drawerEl = document.getElementById('wc-nav-drawer');
    if (!drawerEl) return;

    drawerEl.addEventListener('click', (e) => {
        const link = e.target.closest('a.mobile-nav-link, a.mobile-sub-link');
        if (!link) return;

        const instance = Offcanvas.getInstance(drawerEl);
        if (instance) instance.hide();
    });
}

// Desktop split dropdown: the nav-link href navigates normally.
// The separate .nav-dropdown-btn opens/closes the Bootstrap Dropdown.
// Bootstrap handles this automatically via data-bs-toggle="dropdown",
// but we add aria-expanded sync for the parent <li> for CSS hooks.
function initDesktopDropdownSplit() {
    document.querySelectorAll('.nav-dropdown-btn').forEach((btn) => {
        const li = btn.closest('.nav-item.dropdown');
        if (!li) return;

        btn.addEventListener('shown.bs.dropdown', () => li.classList.add('dropdown-open'));
        btn.addEventListener('hidden.bs.dropdown', () => li.classList.remove('dropdown-open'));
    });
}

// Smooth-scroll the skip-to-main-content link target into view.
function initSkipLink() {
    const skip = document.querySelector('a[href="#main-content"]');
    if (!skip) return;

    skip.addEventListener('click', (e) => {
        const target = document.getElementById('main-content');
        if (!target) return;
        e.preventDefault();
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: false });
        target.scrollIntoView({ behavior: 'smooth' });
    });
}
